import React from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';

import Loading from '../../dialogs/loading';
import Historic from './Historic';

import { bindActionCreators } from 'redux';
import * as actions from '../../../actions/process.home.actions';

import { InfoIcon } from '../../../images/icons/WrapSvg';
import Attach from '@material-ui/icons/AttachFile';

class Instance extends React.Component {
    state = {
        openDialog: false,
        info: {},
        loading: false,
    };

    static getDerivedStateFromProps(props, state) {
        const { info } = props;
        if (info !== state.info) {
            state.info = info;
            return state;
        }
        return null;
    }

    calculatePercentage = (max, score) => {
        if (max > 0) {
            return isNaN(score / max) ? '-%' : ((score / max) * 100).toFixed(0) + '%';
        } else {
            return '-%';
        }
    };

    handleClick = (event) => {
        this.setState({ openDialog: true });
    };

    handleClose = (event) => {
        this.setState({ openDialog: false });
    };

    handleDownload = (event) => {
        this.setState({ loading: true });
        const request = new Request(
            `${process.env.REACT_APP_API_INSTANCE_PDF}/${this.state.info.id}`,
            {
                method: 'GET',
                headers: {
                    Authorization: sessionStorage.token,
                },
            },
        );
        fetch(request).then((response) => {
            response.blob().then((blob) => {
                let url = window.URL.createObjectURL(blob);
                let a = document.createElement('a');
                a.href = url;
                a.download = `${this.state.info.id}.pdf`;
                a.click();
                this.setState({ loading: false });
            });
        });
    };

    render() {
        const { info, loading } = this.state;
        const { puntosefectivos, puntosposibles, nlocal, creado, id, status, ntrabajador } = info;
        const { openDialog } = this.state;
        return (
            <div
                className={classNames('hand flex_full_row padding_top_12 padding_left_24 shadow_down_only')}
            >
                <div
                    className={'flex_full_column padding_bottom_9 barlow_regular_small c_grey_blue'}
                >
                    <span className={'barlowsemicondensed_title c_grey_blue'}>{id}</span>
                    <span className={'c_dark_grey_blue'}>
                        {creado && creado.date && creado.date.substr(0, 16)}
                    </span>
                    <div
                        className={classNames(
                            'margin_bottom_5 flex_full_row',
                            'barlow_regular_small c_grey_blue',
                        )}
                    >
                        <span>{nlocal}</span>
                        <span className="margin_left_12 c_bluish"> {ntrabajador} </span>
                    </div>
                </div>
                {loading && <Loading open opacity />}
                <Attach className={'c_grey_blue'} onClick={this.handleDownload} />
                <InfoIcon className={'margin_left_12 c_golden_yellow'} onClick={this.handleClick} />
                <div
                    className={
                        'flex_auto_column padding_bottom_9 margin_left_6 align_center margin_right_18'
                    }
                >
                    <span
                        className={classNames(
                            'barlowcondensed_semibold_percentage c_black_two text_align_center nowrap',
                            status === 'vencida'
                                ? 'c_lipstick'
                                : status === 'finalizada'
                                    ? 'c_slate_grey'
                                    : 'c_pea',
                        )}
                    >
                        {this.calculatePercentage(puntosposibles, puntosefectivos)}
                    </span>
                </div>
                {openDialog && <Historic id={id} handleClose={this.handleClose} />}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

Instance = connect(
    undefined,
    mapDispatchToProps,
)(Instance);

export default Instance;



// WEBPACK FOOTER //
// ./src/components/complex/forms/Instance.js